<svelte:options accessors />

<script lang="ts">
  import type { EventDispatcher } from "svelte";
  import { BUTTON_ID } from "../..";
  import { localizePrice } from "../../../utils";

  export let price: number | null;
  export let header: string | null;
  export let text: string | null;
  export let moreInfo: string | null;
  export let totalFootprint: number | null;
  export let inCart: boolean | null;
  export let dispatch: EventDispatcher<any>;
  export let modalCallback: () => void;
</script>

{#if price && price !== 0}
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div id={BUTTON_ID}>
    <div class="pina-button-container">
      <div class="pina-button">
        <input
          type="checkbox"
          class="pina-button-input"
          bind:checked={inCart}
          on:change={() => dispatch("toggleOffset", { active: inCart })}
        />

        <div class="pina-button-body">
          <div class="pina-button-text-container">
            <div class="pina-button-headline">{header}</div>
            <div class="pina-button-text">
              <b>{localizePrice(price)}€</b>
              {text}
            </div>
          </div>
          <div class="pina-button-price-container">
            <a class="pina-button-more-info" on:click={modalCallback}
              ><u>{moreInfo}</u></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  .pina-button-container {
    display: flex;
    justify-content: end;

    & .pina-button {
      align-self: end;
      display: flex;
      flex-direction: row;
      align-items: center;
      background-color: #d1beb0;
      gap: 14px;
      position: relative;
      padding: 0.7rem 0.5rem 0.7rem 0.5rem;
      margin-top: -0.5rem;
      margin-bottom: 1rem;

      @media (max-width: 640px) {
        flex-grow: 1;
      }

      & .pina-button-body {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-grow: 1;

        & .pina-button-headline {
          font-size: 12px;
          line-height: 1;
          font-weight: 600;
          margin-bottom: 0.5rem;
          text-wrap: nowrap;
        }

        & .pina-button-text {
          font-size: 12px;
          line-height: 1;
          color: #032b1a;
          text-align: left;
          text-wrap: nowrap;
        }

        & .pina-button-price-container {
          display: flex;
          flex-direction: column;
          justify-content: end;
          min-height: 32px;

          & .pina-button-more-info {
            font-size: 12px;
            line-height: 1;
            color: #032b1a;
            cursor: pointer;
            text-align: right;
          }

          & .pina-button-price {
            font-weight: 700;
            font-size: 1rem;
            font-size: 0.85rem;
            line-height: 1;
            margin-bottom: 0.5rem;
          }
        }
      }

      &:has(input:checked) {
        border-color: #1c7b59;
      }
    }
  }

  .pina-button.active {
    border-color: #1c7b59;
  }

  input.pina-button-input[type="checkbox"] {
    min-width: 19px;
    min-height: 19px;
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    appearance: none;
    outline: 0;
    cursor: pointer;
    transition: background 175ms cubic-bezier(0.1, 0.1, 0.25, 1);
  }

  input.pina-button-input[type="checkbox"]::before {
    position: absolute;
    content: "";
    display: block;
    bottom: 5px;
    left: 7px;
    width: 5px;
    height: 11px;
    border-style: solid;
    border-color: #fff;
    border-width: 0 2px 2px 0;
    border-radius: 1px;
    transform: rotate(38deg);
    opacity: 1;
  }

  input.pina-button-input[type="checkbox"]:checked {
    color: #fff !important;
    border-color: #1c7b59 !important;
    background: #1c7b59 !important;
  }

  input.pina-button-input[type="checkbox"]:checked::before {
    opacity: 1;
  }

  input.pina-button-input[type="checkbox"]:hover {
    cursor: pointer;
  }
</style>
